/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

import { BASE_ENDPOINT } from '../constant';

export type CarBrandOption = {
  car_brand_id: number;
  car_brand_name: string;
};

export type CarModelOption = {
  car_model_id: number;
  car_model_name: string;
};

export type CarYearOption = {
  year: number;
};

export type CarVariantOption = {
  car_variant_id: number;
  car_variant_name: string;
};

export type CarInfo = {
  brand_list: CarBrandOption[];
  model_list: CarModelOption[];
  year_list: CarYearOption[];
  variant_list: CarVariantOption[];
};

export type CarInfoPayload = {
  car_brand?: number;
  car_model?: number;
  manufactured_year?: number;
  car_variant?: number;
};

export type ConsignPayload = {
  consign_name: string;
  consign_mobile: string;
  consign_brand: number;
  consign_model: number;
  consign_variant: number;
  consign_year: number;
  consign_state: number;
  consign_color?: number;
};

/**
 * Unlike the sibling fetchers in this folder, these do not swallow failures into `{}` —
 * the consign form has to tell a network error apart from a server rejection.
 */
export type ApiResult<T> = { ok: true; data: T } | { ok: false; error: string };

const EMPTY_CAR_INFO: CarInfo = {
  brand_list: [],
  model_list: [],
  year_list: [],
  variant_list: [],
};

/** First error string out of a Laravel-style `{ errors: { field: [msg] } }` body. */
const readErrorMessage = (error: any, fallback: string): string => {
  const data = error?.response?.data;
  const firstField: any = Object.values(data?.errors ?? {})[0];

  return firstField?.[0] ?? data?.message ?? error?.message ?? fallback;
};

export const getCarInfo = async (
  payload: CarInfoPayload
): Promise<ApiResult<CarInfo>> => {
  const url = `${BASE_ENDPOINT}/get_car_info`;

  try {
    const response = await axios.request({
      method: 'post',
      url,
      data: payload,
    });

    return { ok: true, data: { ...EMPTY_CAR_INFO, ...response.data } };
  } catch (error) {
    console.error('Fetch Error:', error);

    return {
      ok: false,
      error: readErrorMessage(error, 'Unable to load car list.'),
    };
  }
};

export const submitConsign = async (
  payload: ConsignPayload
): Promise<ApiResult<any>> => {
  const url = `${BASE_ENDPOINT}/consign_car`;

  try {
    const response = await axios.request({
      method: 'post',
      url,
      data: payload,
    });

    return { ok: true, data: response.data };
  } catch (error) {
    console.error('Fetch Error:', error);

    return {
      ok: false,
      error: readErrorMessage(error, 'Submission failed, please try again.'),
    };
  }
};
